// Plain-object shape for a resolved file attachment's metadata, shared across
// the attachment rendering components and the data-fetching hook that produces
// it. This intentionally mirrors the historical Immutable `FileMetadataRecord`
// fields so consumers can move off Immutable without changing behavior.

// Plain-TS equivalent of the internal-schema `displayName` operator: appends the
// extension to the name when present (e.g. `report` + `pdf` -> `report.pdf`).
export function fileMetadataDisplayName({
  name,
  extension
}) {
  return extension ? `${name}.${extension}` : name;
}